@if(showDialog){
    <app-dialog [formConfig]="formConfig"></app-dialog>
}